export const blockIconsCommonactionsWarningNew = (
	<span className='material-symbols-outlined'>warning</span>
);
